import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Axios from 'axios'
import { StoreContextProvider } from './Context/Store'

Axios.defaults.headers.get['Content-Type'] = 'application/json'
Axios.defaults.headers.post['Content-Type'] = 'application/json'

ReactDOM.render(
  // <React.StrictMode>
  <StoreContextProvider>
    <App />
  </StoreContextProvider>
  // </React.StrictMode>,
  , document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
